




































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  apiGetGameServerList,
  apiSaleBan,
  apiSaleUnBan,
  apiSaleBanEdit,
} from "../../../config/service";

@Component({
  components: {},
})
export default class Box extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public gameList;
  public modalShow = false;
  public formInline = {
    game_id: undefined,
    server_id: undefined,
    role_id: "",
    ban_role: 0,
    ban_coin: 0,
    ban_equip: 0,
    reason: "",
  };
  public visible = false;
  public key = "";
  public id = "";
  public serverList = [];
  public show(row?, key?) {
    if (key) {
      this.visible = true;
      this.key = key;
      this.id = row.id;
      for (const iterator of Object.keys(this.formInline)) {
        this.formInline[iterator] = row[iterator];
      }
      this.getServer(row.game_id, true);
    }
    this.modalShow = true;
  }
  public cancel() {
    this.modalShow = false;
  }
  public onVisiblenChange(val) {
    if (!val) {
      Object.assign(this.$data, (this as any).$options.data.call(this));
    }
  }
  public async submit() {
    let res;
    if (this.key === "unset") {
      res = await apiSaleUnBan({
        id: this.id,
      });
    } else if (this.key === "revamp") {
      res = await apiSaleBanEdit({
        id: this.id,
        ban_role: this.formInline.ban_role,
        ban_coin: this.formInline.ban_coin,
        ban_equip: this.formInline.ban_equip,
        reason: this.formInline.reason,
      });
    } else {
      res = await apiSaleBan({
        ...this.formInline,
      });
    }
    if (res.code === 0) {
      this.$Message.success(res.msg);
      this.$emit("init");
      this.modalShow = false;
    }
  }
  public async getServer(val, status?) {
    this.serverList = [];
    if (!status) {
      this.formInline.server_id = undefined;
    }
    if (!val) return;
    const res = await apiGetGameServerList({
      game_id: val,
    });
    if (res.code === 0) {
      this.serverList = res.data;
    }
  }
}
